﻿import React from 'react';
import { DialogContent as MuiDialogContent } from '@mui/material';
import { DialogContentProps } from '@mui/material';

function DialogContent(props: DialogContentProps) {
  const { children, ...other } = props;
  return <MuiDialogContent {...other}>{children}</MuiDialogContent>;
}
export default DialogContent;
